module.exports = __webpack_public_path__ + "static/media/2.cc1e32d6.jpeg";